import { render } from "./editClient.vue?vue&type=template&id=0dc31046&scoped=true"
import script from "./editClient.vue?vue&type=script&lang=js"
export * from "./editClient.vue?vue&type=script&lang=js"

import "./editClient.vue?vue&type=style&index=0&id=0dc31046&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/greenbelt_garbage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dc31046"]])

export default __exports__